import styled from "styled-components";
import Button from "../Button/Button";

export const StyledRadioWrapper = styled.div``;

export const RadioContainer = styled.div`
  display: flex;
  margin-top: 25px;
  font-family: "Inter", sans-serif;


  > label:not(:last-child) {
    margin-right: 50px;

    @media only screen and (max-width: 375px) {
      margin-right: auto;
    }
  }
`;

export const StyledBondTitle = styled.h1`
  font-family: "Inter", sans-serif;
  display: flex;
  flex-direction: column;
  row-gap: 20px;
  justify-content: space-between;
  max-width: 660px;
  font-size: 22px;
  line-height: 1.5em;
  color: var(--hero-text);
  font-weight: 600;
  padding: 20px;
  background-color: var(--hero-background);
  border-radius: 8px;
  margin-bottom: 24px;
  max-width: 800px;
  min-width: 800px;
  filter: drop-shadow(0px 10px 8px rgba(0, 0, 0, 0.16));

  @media only screen and (max-width: 768px) {
    font-size: 18px;
  }

  @media (max-width: 1300px) {
    min-width: 700px;
  }
  @media (max-width: 1100px) {
    min-width: 650px;
  }
  @media (max-width: 1024px) {
    min-width: unset;
  }
`;

export const StyledBondPreview = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (max-width: 600px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
`

export const StyledBondInfo = styled.div`
  font-size: 18px;
  font-weight: 500;
  color: var(--text);
  line-height: 24px;
  font-family: "Inter", sans-serif;

  @media only screen and (max-width: 768px) {
    font-size: 16px;
  }
`;

export const ContainerForm = styled.div`
  position: relative;
  background: #f6f7fb;
  margin: 0 auto;
  display: flex;
  /* max-width: 1110px; */
  gap: 20px;
  @media only screen and (max-width: 1024px) {
    flex-direction: column;
  }
  @media screen and (min-width: 1440px){
    /* max-width: 1440px; */
    /* padding-left: 100px; */
  }
`;

export const StyledSidebar = styled.div`
  
  width: 100%;
  border-left: 10px solid var(--primary);
  padding-left: 20px;
  height: fit-content;
  display: flex;
  font-family: "Inter", sans-serif;
  flex-direction: column;
  gap: 15px;
  filter: drop-shadow(0px 10px 8px rgba(0, 0, 0, 0.16));

 
`;
export const WrapperForm = styled.div`
  width: 100%;
  max-width: 800px;
  min-width: 800px;
  @media (max-width: 1300px) {
    min-width: 700px;
  }
  @media (max-width: 1100px) {
    min-width: 650px;
  }
  @media (max-width: 1024px) {
    min-width: unset;
    max-width: unset;
  }
`;

export const StyledSidebarTitle = styled.div`
  font-size: 24px;
  line-height: 24px;
  font-weight: 500;
  color: var(--primary);

  @media only screen and (max-width: 768px) {
    font-size: 22px;
    line-height: 22px;

    &:nth-of-type(3) {
      margin-bottom: 44px;
    }
  }
`;
export const StyledSidebarText = styled.div`
  font-size: 18px;
  font-weight: 400;
  line-height: 27px;
`;

export const Wrapper = styled.div`
  padding: 20px 20px;
  background: white;
  filter: drop-shadow(0px 10px 8px rgba(0, 0, 0, 0.16));
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 4px;
`;

export const StyledFormHeader = styled.div`
  background-color: var(--hero-background);
  color: var(--hero-text);
  padding: 20px 20px;
  border-radius: 4px;
  filter: drop-shadow(0px 10px 8px rgba(0, 0, 0, 0.16));

  @media only screen and (max-width: 768px) {
    padding: 15px 15px;
  }
`;

export const StyledTitle = styled.div`
  font-family: "Inter", sans-serif;
  @media only screen and (max-width: 768px) {
    margin-bottom: -9px;
  }
`;

export const StyledExtraInfo = styled.div`
  font-size: 16px;
  margin-top: 20px;
  line-height: 1.5em;
  white-space: pre-wrap;
  display: inline-block;
  font-weight: 400;
  @media only screen and (max-width: 768px) {
    font-size: 14px;
    margin-top: 23px;
  }
`;

export const Title = styled.span`
  display: block;
  font-style: normal;
  font-family: "Inter", sans-serif;
  font-weight: 600;
  font-size: 22px;
  line-height: 137.4%;
  margin-bottom: 20px;
  color: var(--header);
  white-space: pre-wrap;
  @media only screen and (max-width: 768px) {
    font-size: 18px;
    margin-bottom: 12px;
  }
`;

export const SubTitle = styled.span`
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 1.5em;
  display: inline-block;
  font-family: "Inter", sans-serif;
  @media only screen and (max-width: 768px) {
    font-size: 14px;
  }
`;

export const Info = styled.div`
  font-size: 20px;
  font-weight: 400;
  line-height: 25px;
  letter-spacing: 0;
  text-align: left;
  margin-bottom: 30px;
`;

export const StepsContainer = styled.div`
  display: flex;
  gap: 20px;
  margin-bottom: 50px;
  justify-content: center;
`;

export const Container = styled.div`
  padding: 40px;
  display: flex;
  flex-direction: column;
  width: fit-content;
  margin: 0 auto;
  font-family: var(--base-font);

  @media only screen and (max-width: 768px) {
    padding: 40px 20px;
  }
`;

export const RadioLabel = styled.label`
  font-style: normal;
  font-size: 16px;
  line-height: 1.5em;
  font-weight: 400;
  color: var(--hero-text);
  @media only screen and (max-width: 768px) {
    font-size: 14px;
  }
  > span {
    color: red;
  }
`;

export const StyledLeftFields = styled.span`
  position: absolute;
  bottom: 80px;
  left: 50%;
  transform: translate(-50%, 50%);
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 1.5em;
  white-space: nowrap;
  @media only screen and (max-width: 768px) {
    font-size: 14px;
  }

  color: #f80d0d;
`;

export const StyledLoadingIndemnitor = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: -25px;
`;

export const StyledAddIndemnitor = styled.button`
  position: absolute;
  bottom: 80px;
  left: 50%;
  transform: translate(-50%, 50%);
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 126.4%;

  color: var(--primary);
`;

export const StyledSubmitContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
`;
export const StyledIndemnitorDivider = styled.div`
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  &:not(:last-child) {
    border-bottom: 2px solid var(--primary);
    padding-top: 40px;
  }
`;

export const StyledRemoveIndemnitor = styled.button`
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 126.4%;
  z-index: 10;
  margin-bottom: -24px;
  /* or 25px */

  color: var(--primary);

  @media only screen and (max-width: 400px) {
    font-size: 14px;
  }
`;

export const StyledIndemnitorLabel = styled.span`
  font-weight: 700;
`;

export const StyledPopover = styled.div`
  width: 200px;
  background: white;
  color: red;
  padding: 20px;
  overflow-wrap: break-word;
  border-radius: 5px;
  position: absolute;
  right: 20px;
  top: 20px;
  z-index: 5;
`;
